import FilmIcon from '@/assets/images/icons/film.svg'
import VideoPlaylistIcon from '@/assets/images/icons/video-playlist.svg'
import CommentsIcon from '@/assets/images/icons/b-comment.svg'
import CockadeIcon from '@/assets/images/icons/cockade.svg'
import GoldCoinIcon from '@/assets/images/icons/gold-coin-2.svg'
import ShoppingLabelIcon from '@/assets/images/icons/shopping-label.svg'
import CommentAddIcon from '@/assets/images/icons/comment-add.svg'
import ChessKingIcon from '@/assets/images/icons/chess-king.svg'
import FlagIcon from '@/assets/images/icons/flag.svg'
import HyperlinkIcon from '@/assets/images/icons/hyperlink.svg'

const planPerksIcons = {
  'film-icon': FilmIcon,
  'video-playlist-icon': VideoPlaylistIcon,
  'comments-icon': CommentsIcon,
  'cockade-icon': CockadeIcon,
  'gold-coin-icon': GoldCoinIcon,
  'shopping-label-icon': ShoppingLabelIcon,
  'comment-add-icon': CommentAddIcon,
  'chess-king-icon': ChessKingIcon,
  'flag-icon': FlagIcon,
  'hyperlink-icon': HyperlinkIcon,
}

const getPlanPerksWithIcons = (perks) => {
  if (!perks) return []
  return perks.map((perk) => ({
    ...perk,
    icon: planPerksIcons[perk.icon],
  }))
}

const comparePlans = (plans, plan, compareToPlan) => {
  const perksWithIcons = getPlanPerksWithIcons(plans[plan])
  const perksToCompare = perksWithIcons.filter(
    (perk) => perk.includeInComparison,
  )
  const compareToPerks = plans[compareToPlan]
  return perksToCompare.reduce((acc, perk) => {
    const hasPerk = compareToPerks.some(
      (compareToPerk) => compareToPerk.text === perk.text,
    )
    return hasPerk ? acc : [...acc, perk]
  }, [])
}

export { planPerksIcons, comparePlans, getPlanPerksWithIcons }
